module.exports = __webpack_public_path__ + "files/bcc18f29561e2958268dd9988e9ef6e1.png";